<div class="mat-drawer-inner-container"><ng-content></ng-content></div>